import { useState, useCallback } from 'react'
import { supabase } from '@/shared/lib/supabase'

interface UseMagicLinkReturn {
  sendMagicLink: (email: string) => Promise<boolean>
  isSending: boolean
  error: string | null
  clearError: () => void
}

export function useMagicLink(): UseMagicLinkReturn {
  const [isSending, setIsSending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const sendMagicLink = useCallback(async (email: string): Promise<boolean> => {
    setIsSending(true)
    setError(null)

    try {
      const { error: otpError } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/auth/callback`,
        },
      })

      if (otpError) {
        setError(otpError.message)
        return false
      }

      return true
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error')
      return false
    } finally {
      setIsSending(false)
    }
  }, [])

  const clearError = useCallback(() => setError(null), [])

  return { sendMagicLink, isSending, error, clearError }
}
